module.exports = __webpack_public_path__ + "media/block1.f49df199.mp3";